import { Avatars } from "@/molecules/Avatars"

import type { ContributorsCellComponent } from "."

export const ContributorsCell: ContributorsCellComponent = (t) =>
  function ContributorsCellComponent(value, { contributorsCount } = {}) {
    return (
      <Avatars
        list={value}
        count={contributorsCount}
        max={contributorsCount ? 2 : 1}
        t={t}
      />
    )
  }
